import * as service from './service'
export default {
  namespace: 'courierTaskTaskDetail',
  state: {
    taskDetail: {}
  },
  effects: {
    * taskDetail ({ payload }, { call, put }) {
      const res = yield call(service.taskDetail, payload)
      if (res.data.status === 200) {
        yield put({
          type: 'save',
          payload: {
            taskDetail: { ...res.data.data }
          }
        })
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
